import { Badge, Col, Container, Row } from 'react-bootstrap';

// components
import { PricingCards1, PlanItem } from 'components/pricing';

type PricingPlansProps = {
    plans: PlanItem[];
    heading:string;
};

const PricingPlans = ({ plans,heading}: PricingPlansProps) => {
    return (
        <section className="section py-6 position-relative">
            <Container>
                <Row>
                    <Col className="text-center">
                        <Badge pill bg="" className="badge-soft-primary px-2 py-1">
                            Plans
                        </Badge>
                        <h1 className="display-5 fw-semibold">{heading}</h1>
                        
                    </Col>
                </Row>
                <PricingCards1 plans={plans}  containerClass=" d-flex justify-content-center align-items-start mt-0 mt-sm-5" />
            </Container>
        </section>
    );
};


export default PricingPlans;
